import React from "react";

import { HStack, Text } from "@/components/ui";

import { generateText } from "../utils";

import PlaceholderAvatar from "./placeholder-avatar";

export default function PlaceholderMutualFollowers() {
  return (
    <HStack alignItems="center" space={2}>
      <HStack alignItems="center" space={-2}>
        <PlaceholderAvatar
          size={20}
          className="rounded-full ring-2 ring-white dark:ring-gray-900"
        />
        <PlaceholderAvatar
          size={20}
          className="rounded-full ring-2 ring-white dark:ring-gray-900"
        />
        <PlaceholderAvatar
          size={20}
          className="rounded-full ring-2 ring-white dark:ring-gray-900"
        />
      </HStack>

      <Text theme="placeholder">{generateText(12)}</Text>
    </HStack>
  );
}
